import { StyleSheet } from 'react-native';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { neutrals } from 'src/theme/colors';

const sharedStyle = StyleSheet.create({
  contentWrapper: {
    width: '100%',
    flexDirection: 'row',
    gap: 16,
  },
  button: {
    width: 223,
    height: 50,
  },
  buttonText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  modal: {
    width: 884,
    minHeight: 500,
    maxHeight: 542,
    padding: 'auto',
    overflow: 'visible',
  },
  content: {
    paddingTop: 21,
    paddingBottom: 24,
    //paddingHorizontal: 32,
    gap: 16,
    overflow: 'visible',
    alignItems: 'center',
    borderRadius: CornerRadius.Huge,
  },
  titleWrapper: {
    width: '100%',
    paddingBottom: 21,
    justifyContent: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    width: '100%',
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  headerLeft: { flex: 1 },
  headerRight: { flex: 1 },
  header: {
    paddingHorizontal: 32,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: neutrals.neutralGrays.snow,
  },
});
export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  modal: {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    padding: 0,
  },
  content: {
    gap: 0,
    height: '100%',
  },
  titleWrapper: {
    width: '100%',
    paddingVertical: 12,
    justifyContent: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    width: '100%',
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  headerLeft: { flex: 1, justifyContent: 'center', alignItems: 'flex-start' },
  headerRight: { flex: 1, justifyContent: 'center', alignItems: 'flex-end' },
  header: {
    paddingHorizontal: 12,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const sharedStyleModal = StyleSheet.create({
  content: {
    paddingBottom: 24,
    paddingTop: 17,
    paddingHorizontal: 32,
    gap: 24,
    alignItems: 'center',
  },
  titleWrapper: {
    width: '100%',
    paddingBottom: 17,
    borderBottomWidth: 1,
    borderColor: neutrals.neutralGrays.snow,
    justifyContent: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    width: '100%',
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  button: {
    width: 223,
    height: 50,
  },
  buttonText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
  },
  iconButton: {
    position: 'absolute',
    bottom: '50%',
    backgroundColor: 'white',
    zIndex: 2,
    shadowColor: neutrals.black,
    shadowOffset: { width: 3, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
});

export const styleModalDesktop = StyleSheet.create({
  ...sharedStyleModal,
  contentWrapper: {
    paddingBottom: 20,
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    gap: 16,
  },
});

export const styleModalMobile = StyleSheet.create({
  ...sharedStyleModal,
  contentWrapper: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    // width: '100%',
    //height: '100%',
    flexDirection: 'row',
    gap: 16,
  },
});
